import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPictureFallback]',
  standalone: true
})
export class PictureFallbackDirective {
  constructor(
    private elRef: ElementRef,
  ) { }

  @HostListener('error')
  onError(){
    const sourceNodes: HTMLElement[] = this.elRef.nativeElement.parentNode.querySelectorAll('source');
    if(!sourceNodes.length){return}

    sourceNodes.forEach(node => node.remove())
  }
}
